function reloadCardImages(el) {
  el.querySelectorAll("img[data-unloaded-src]").forEach((img) => {
    img.src = img.dataset.unloadedSrc;
    if (img.dataset.unloadedSrcset) img.srcset = img.dataset.unloadedSrcset;
    delete img.dataset.unloadedSrc;
    delete img.dataset.unloadedSrcset;
  });
}

function unloadCardImages(el) {
  el.querySelectorAll("img[src]").forEach((img) => {
    img.dataset.unloadedSrc = img.src;
    if (img.srcset) img.dataset.unloadedSrcset = img.srcset;
    img.removeAttribute("src");
    img.removeAttribute("srcset");
  });
}

function initProductSwiper(el) {
  // Destroying Swiper (below) only tears down its JS instance - it never
  // touches the <img> elements, so a decoded image that scrolled near the
  // viewport once stays fully decoded in memory forever. On a long
  // infinite-scroll session that decoded-image memory grows with every
  // product ever loaded (not just what's on screen), which is what was
  // still crashing iOS after the Swiper-instance and DOM-count fixes.
  // Restoring here + unloading in teardownProductSwiper keeps only cards
  // within the ~1000px window actually holding decoded image data.
  reloadCardImages(el);

  if (el.swiper || el.dataset.swiperInitialized) return;

  el.dataset.swiperInitialized = "true";

  const nextBtn = el.querySelector(".swiper-button-next");
  const prevBtn = el.querySelector(".swiper-button-prev");
  const paginationEl = el.querySelector(".swiper-pagination");

  new Swiper(el, {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 10,

    preloadImages: false,

    lazy: {
      loadPrevNext: true,
    },

    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },

    pagination: paginationEl
      ? {
          el: paginationEl,
          clickable: true,
        }
      : false,
  });
}

function teardownProductSwiper(el) {
  if (el.swiper) {
    // deleteInstance + cleanStyles: fully detaches Swiper's touch/resize
    // listeners and internal slide state so the element can be garbage
    // collected instead of piling up as you scroll a long collection.
    el.swiper.destroy(true, true);
    delete el.dataset.swiperInitialized;
  }
  unloadCardImages(el);
}

let swiperVisibilityObserver = null;

function getSwiperVisibilityObserver() {
  if (swiperVisibilityObserver) return swiperVisibilityObserver;

  swiperVisibilityObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          initProductSwiper(entry.target);
        } else {
          teardownProductSwiper(entry.target);
        }
      });
    },
    {
      // Keep a ~1000px window of cards "live" around the viewport. Cards
      // that scroll further away than that get their Swiper instance
      // destroyed. Without this, a long infinite-scroll collection page
      // (100s of products) accumulates a live Swiper instance per card
      // forever, which crashes iOS Safari/Chrome (WKWebView OOM) after
      // enough scrolling.
      rootMargin: "1000px 0px 1000px 0px",
    },
  );

  return swiperVisibilityObserver;
}

function initVisibleSwipers(scope = document) {
  const swipers = scope.querySelectorAll(".card-product-media-swiper");
  const observer = getSwiperVisibilityObserver();

  swipers.forEach((swiper) => {
    observer.observe(swiper);
  });
}

window.addEventListener("load", () => {
  initVisibleSwipers();
});

document.addEventListener("facet:rendered", () => {
  initVisibleSwipers(document);
});
